import { useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

export enum FeatureFlag {
  EnableChat = 'enableZendeskChat',
}

/**
 * Return value of launch darkly boolean flag. Because we are using react, flags passed in
 * should be in camel case rather than dashes e.g. use-this-feature should be useThisFeature
 * @param flag camel case flag to check
 * @returns LD flag value
 */
const useFeature = (flag: string) => {
  const flags = useFlags();
  const [flagValue, setFlagValue] = useState(flags[flag] ?? false);

  useEffect(() => {
    setFlagValue(flags[flag] ?? false);
  }, []);

  return flagValue;
};

export default useFeature;
